module.exports = __webpack_public_path__ + "static/media/phone.5b440c14.png";